<template>
  <Modal id="cmp-add-company" @cancelled="onCancel">
    <template slot="header">New Company</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'companyName'"
          required
          v-bind="textFieldConfig"
          :value="company.companyName"
          :placeholder="'Company'"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <TextField
          class="m1"
          :id="'city'"
          required
          v-bind="textFieldConfig"
          :value="company.city"
          :placeholder="'City'"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        ></TextField>
        <Dropdown
          :options="countries"
          class="m2"
          :selected="selectedCountry"
          :placeholder="'Country'"
          v-on:selectedChange="e => onDropdownChange('country', e)"
          :listHeight="95"
          box
        ></Dropdown>
        <Dropdown
          :options="groups"
          class="m2"
          :selected="company.groups || []"
          :placeholder="'Add To Group (Optional)'"
          v-on:selectedChange="e => onDropdownChange('groups', e)"
          box
          :listHeight="95"
          multiple
          :maxSelection="3"
        ></Dropdown>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button
        class="dt-button v1 s6"
        :class="{'disabled': !isFormValid}"
        :disabled="!isFormValid"
        @click.stop="addNewContact"
      >Add New Contact</button>
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";

import isEmail from "validator/lib/isEmail";
import Modal from "../modal/modal";
import { createTV } from '../../models/text-value.model';
import { ContactService } from "./contact.service";
export default {
  components: {
    Modal
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    countries: {
      type: Array,
      default: () => []
    },
    selectedCountry:{
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      company: createCompany(),
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email"
        })
      ],
      selectedCountry:{},
      validationResult: {}
    };
  },
  mounted: function() {},
  computed: {
    coutriesTV:function(){
        return createTV(this.countries);
    },
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }
  },
  methods: {
    onTextFieldValueChange: function(key, value) {
      this.company[key] = value;
      if(key==='city'){
        this.$emit("checkcity", value);
      }
     
     
    },
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function(name, value) {
      switch (name) {
        case "groups": {
          this.company.groups = value;
          this.company["group_id1"] = this.company.groups[0] && this.company.groups[0].value;
          this.company["group_id2"] = this.company.groups[1] && this.company.groups[1].value;
          this.company["group_id3"] = this.company.groups[2] && this.company.groups[2].value;
          console.log(this.company.groups.map(e => e.value));
          break;
        }
        case "country": {
          console.log('country',value)
          this.company.country = value.value;
          this.$emit("setCity", value);
          break;
        }
      }

      console.log(this.company);
    },
    addNewContact: function(e) {
      this.$emit("new_contact", {
        type: "company",
        contact: this.company
      });
    }
  }
};

const createCompany = ({ companyName = "", city = "", country = "", groups = [] } = {}) => {
  return {
    companyName,
    city,
    country,
    groups
  };
};
</script>

<style lang="scss" scoped>
.form-group {
  display: flex;
  flex-direction: column;

  .dt-input-box--container {
    flex: 1;
    margin: 5px 0px;
    margin-left: 0px;
  }

  .group-input {
    margin-top: 25px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
}

.dt-modal--options {
  button {
    height: 30px;
  }
}
</style>
